import { Box, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import CustomDropdown from "src/components/customDropdown";

export const AcnvModelBasedBamForm = (props) => {
  const { disabled, appConf, handleChange, formData } = props;
  const { t } = useTranslation();

  return (
    <>
      <Box minWidth="100%">
        <TextField
          label={t("Project Title")}
          name="name"
          variant="outlined"
          required
          disabled={disabled}
          onChange={handleChange}
          value={formData.name}
        />
        <CustomDropdown
          name="kit"
          formData={formData}
          labelTitle={t("Kit")}
          values={appConf.entities.kits}
          disabled={disabled}
          changeHandler={handleChange}
          searchable={true}
        />
        <CustomDropdown
          name="pipeline_class"
          formData={formData}
          labelTitle={t("Pipeline Type")}
          values={appConf.entities.pipeline_classes["acnv_bam"] ?? {}}
          disabled={disabled}
          changeHandler={handleChange}
        />
      </Box>
      <TextField
        fullWidth
        id="project-desc"
        name="description"
        value={formData.description ?? ""}
        label={t("Project Description")}
        placeholder={t("Describe your project (optional)")}
        multiline
        rows={4}
        variant="outlined"
        disabled={disabled}
        onChange={handleChange}
      />
    </>
  );
};
